import { setLocal, getLocal, setSessionJSON,getSessionJSON,setSession,getSession, clearSession, getStorageJSON, removeStorage } from '@/utils/cookie'
import { getTokenApi, Login, getWxStudentInfo } from "@/api/common"
import { mobileBind} from "@/api/bind"

import store from '@/store'
import { Notify } from 'vant'
import { router } from '@/router';
const authCookieName = 'Authorization' // cookie缓存名称
const userInfoCacheName = 'userInfo' // 用户信息缓存名称
import { getCode } from "@/utils/wx.js";

export function  getToken()  {
  return getLocal(authCookieName) || ''

}
export function  getSchoolCode()  {
  return getSessionJSON('studentTitleCard') || ''
}


// 用于区分中国人民警察大学和其他学校
export function getSchool() {
  return '其他'
}



export async function setToken(_token) {
  // _token && console.log('setToken', _token);
  if (!_token||_token==''||_token==undefined) {
    const { data } = await getTokenApi()
    console.log(123,data);
    
    _token = data.body.token
  }
  setLocal(authCookieName, _token)
}


export function clearToken() {
  clearSession(authCookieName)
}

export function getUserInfo(onlyOne = false) {
  if (onlyOne) { // 仅获取一次 store有数据就不获取了
    if (Object.keys(store.userInfo).length) {
      return store.userInfo
    }
  }
  return getWxStudentInfo().then(res => {
    const token = sessionStorage.getItem('Authorization')
    res.data.obj.token = token
    const userInfo = res.data.obj || {}
    const type = res.data.body;
    userInfo.type = type;
    userInfo.hasOpenId = true;
    userInfo.appid = window.context.VITE_APPID;
    store.commit('SER_USER_INFO', userInfo)
    setSessionJSON(userInfoCacheName, userInfo)
    return userInfo
  })
}